const LANGUAGE = {
  SET_LANGUAGE: 'LANGUAGE_SET_LANGUAGE'
}

export default LANGUAGE
